import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-message",
  "use": "icon-message-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-message\"><defs><style type=\"text/css\"></style></defs><path d=\"M128 112h768c35.346 0 64 28.654 64 64v558.33c0 35.346-28.654 64-64 64H640l-79.793 91.376c-23.249 26.624-63.679 29.36-90.303 6.111a64 64 0 0 1-6.111-6.11L384 798.33H128c-35.346 0-64-28.654-64-64V176c0-35.346 28.654-64 64-64z m138 392.026c26.51 0 48-21.876 48-48.861 0-26.985-21.49-48.861-48-48.861s-48 21.876-48 48.86c0 26.986 21.49 48.862 48 48.862z m246 0c26.51 0 48-21.876 48-48.861 0-26.985-21.49-48.861-48-48.861s-48 21.876-48 48.86c0 26.986 21.49 48.862 48 48.862z m246 0c26.51 0 48-21.876 48-48.861 0-26.985-21.49-48.861-48-48.861s-48 21.876-48 48.86c0 26.986 21.49 48.862 48 48.862z\" p-id=\"9438\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/message.svg
// module id = G2zY
// module chunks = 102